/**
 * @flow
 * @author: Vamsi Tallam
 * */

import React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import bookNowConstants from '../../../constants/bookNowFormConstants'
import { SEARCH_OPTIONS } from '../../../constants/googlePlacesConstants'
import { isRequired } from '../../../utils/FormValidations'
import {
  InputComponent,
  PlacesSuggestionContainer,
  SuggestionContainer,
  SuggestionContainerMainText,
  SuggestionContainerSecondaryText,
  SuggestionInnerContainer,
  LocationWrapper
} from './styledComponents'

type Props = {
  searchOptions: Object,
  handleChange: string => mixed,
  defaultValue?: string
}

class LocationSearchInput extends React.Component<Props> {
  static defaultProps = {
    searchOptions: SEARCH_OPTIONS,
    handleChange: () => {}
  }
  constructor(props) {
    super(props)
    this.state = {
      address: props.defaultValue || ''
    }
  }

  storeInputRef = ref => {
    this.inputRef = ref
  }

  storeAutocompleteRef = ref => {
    this.autoCompleteRef = ref
  }

  validate = () => this.inputRef.validate()

  handleChange = selected => {
    const { handleChange } = this.props
    this.setState({ address: selected })
    handleChange(selected)
  }

  handleSelect = selected => {
    this.setState({ address: selected })
    this.props.onBlur(selected)
  }

  handleError = (status, clearSuggestions) => {
    console.log('Error from Google Maps API', status) // eslint-disable-line no-console
    this.setState({}, () => {
      clearSuggestions()
    })
    this.props.handleError()
  }

  clearValues = () => {
    this.inputRef.state.value = ''
    this.setState({
      address: ''
    })
  }

  render() {
    const { address } = this.state
    const {
      cityPlaceHolderText,
      inputType,
      required,
      suggestionsContainerWidth,
      searchOptions,
      defaultValue
    } = this.props
    const value = address.split(',')[0]
    return (
      <div>
        <PlacesAutocomplete
          onChange={this.handleChange}
          value={value}
          onSelect={this.handleSelect}
          onError={this.handleError}
          searchOptions={searchOptions}
          ref={this.storeAutocompleteRef}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <LocationWrapper>
              <div>
                <InputComponent
                  {...getInputProps({
                    placeholder: cityPlaceHolderText
                  })}
                  validate={isRequired}
                  required={required}
                  value={value}
                  innerRef={this.storeInputRef}
                  inputType={inputType}
                  defaultValue={defaultValue}
                />
              </div>
              {suggestions.length > 0 && (
                <PlacesSuggestionContainer
                  suggestionsContainerWidth={suggestionsContainerWidth}
                >
                  {suggestions.map(suggestion => (
                    <SuggestionContainer
                      {...getSuggestionItemProps(suggestion)}
                      active={
                        suggestion.active
                          ? bookNowConstants.ACTIVE
                          : bookNowConstants.INACTIVE
                      }
                    >
                      <SuggestionInnerContainer>
                        <SuggestionContainerMainText>
                          {suggestion.formattedSuggestion.mainText}
                        </SuggestionContainerMainText>
                        <SuggestionContainerSecondaryText>
                          {suggestion.formattedSuggestion.secondaryText}
                        </SuggestionContainerSecondaryText>
                      </SuggestionInnerContainer>
                    </SuggestionContainer>
                  ))}
                </PlacesSuggestionContainer>
              )}
            </LocationWrapper>
          )}
        </PlacesAutocomplete>
      </div>
    )
  }
}

export default LocationSearchInput



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/ApplyForFranchiseForm/LocationSearchInput.js